import ValueX from '../types/ValueX';

export default class MedicationX extends ValueX {
    static __className = 'MedicationX';

    constructor(constructJson) {
        super(constructJson, 'medication', 'MedicationX');
    }
}
